import React from "react";

function PageHeader({
  title,
  subtitle,
  icon = "bi bi-graph-up-arrow",
  variant = "default", // default, minimal, card, simple
}) {
  if (variant === "minimal") {
    return (
      <div style={{ marginTop: "24px", marginBottom: "32px" }}>
        <h1
          className="fw-bold text-capitalize mb-1"
          style={{
            color: "#1F4D2C",
            fontSize: "2rem",
            fontFamily: "Inter, sans-serif",
            letterSpacing: "-0.02em",
            lineHeight: 1.2,
          }}
        >
          {title}
        </h1>
        <div
          style={{
            width: "60px",
            height: "4px",
            background: "linear-gradient(90deg, #1F4D2C 0%, #83c14a 100%)",
            borderRadius: "2px",
            marginTop: "8px",
          }}
        ></div>
        {subtitle && (
          <p
            className="mb-0 mt-2"
            style={{
              color: "#6b7280",
              fontSize: "0.95rem",
              fontFamily: "Inter, sans-serif",
            }}
          >
            {subtitle}
          </p>
        )}
      </div>
    );
  }

  if (variant === "simple") {
    return (
      <div
        style={{
          marginTop: "24px",
          marginBottom: "32px",
          display: "flex",
          alignItems: "center",
          gap: "16px",
        }}
      >
        <div
          style={{
            width: "4px",
            height: "48px",
            background: "linear-gradient(180deg, #1F4D2C 0%, #83c14a 100%)",
            borderRadius: "2px",
          }}
        ></div>
        <div>
          <h1
            className="fw-bold text-capitalize mb-0"
            style={{
              color: "#1F4D2C",
              fontSize: "1.75rem",
              fontFamily: "Inter, sans-serif",
              letterSpacing: "-0.02em",
              lineHeight: 1.2,
            }}
          >
            {title}
          </h1>
          {subtitle && (
            <p
              className="mb-0 mt-1"
              style={{
                color: "#6b7280",
                fontSize: "0.9rem",
                fontFamily: "Inter, sans-serif",
              }}
            >
              {subtitle}
            </p>
          )}
        </div>
      </div>
    );
  }

  // Default variant
  return (
    <div
      style={{
        marginTop: "24px",
        marginBottom: "24px",
        paddingBottom: "16px",
        borderBottom: "2px solid #e5e7eb",
        position: "relative",
      }}
    >
      <div
        style={{
          position: "absolute",
          bottom: "-2px",
          left: 0,
          width: "80px",
          height: "2px",
          background: "linear-gradient(90deg, #1F4D2C 0%, #83c14a 100%)",
        }}
      ></div>
      <h1
        className="fw-bold text-capitalize mb-0"
        style={{
          color: "#1F4D2C",
          fontSize: "1.75rem",
          fontFamily: "Inter, sans-serif",
          letterSpacing: "-0.02em",
          display: "flex",
          alignItems: "center",
          gap: "12px",
        }}
      >
        <span
          style={{
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            width: "48px",
            height: "48px",
            borderRadius: "12px",
            background: "linear-gradient(135deg, #1F4D2C 0%, #83c14a 100%)",
            boxShadow: "0 4px 6px rgba(31, 77, 44, 0.2)",
          }}
        >
          <i
            className={icon}
            style={{ color: "#ffffff", fontSize: "1.5rem" }}
          ></i>
        </span>
        {title}
      </h1>
      {subtitle && (
        <p
          className="mb-0 mt-2"
          style={{
            color: "#6b7280",
            fontSize: "0.95rem",
            fontFamily: "Inter, sans-serif",
            marginLeft: "60px",
          }}
        >
          {subtitle}
        </p>
      )}
    </div>
  );
}

export default PageHeader;
